import React, { useState, useEffect } from 'react';
import '../SitoWeb.css';
import { Phone, Mail, MapPin, ChevronDown, ArrowRight, Building2, HardHat, Ruler, PaintBucket, Shield, Clock, Menu, X, Leaf, Monitor, Scale, Cog } from 'lucide-react';

const LOGO = 'https://customer-assets.emergentagent.com/job_colabella-tutorials/artifacts/wcwuz41r_LOGO.png';

const images = {
  hero: 'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=1920&q=80',
  hero2: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1920&q=80',
  about: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&q=80',
  about2: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&q=80',
  project1: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800&q=80',
  project2: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80',
  project3: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80',
  project4: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80',
  project5: 'https://images.unsplash.com/photo-1600573472550-8090b5e0745e?w=800&q=80',
  project6: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&q=80',
};

const SitoWeb = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [formData, setFormData] = useState({ nome: '', email: '', telefono: '', messaggio: '' });
  const [formSent, setFormSent] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const scrollTo = (id) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormSent(true);
    setTimeout(() => setFormSent(false), 5000);
    setFormData({ nome: '', email: '', telefono: '', messaggio: '' });
  };

  const servizi = [
    { icon: Building2, title: 'Costruzioni Residenziali', desc: 'Realizziamo abitazioni di pregio, dalla villetta unifamiliare ai complessi residenziali, con attenzione ai dettagli e materiali di qualità.' },
    { icon: HardHat, title: 'Ristrutturazioni', desc: 'Interventi di ristrutturazione completa o parziale, rispettando i tempi e il budget concordato, con soluzioni innovative.' },
    { icon: Ruler, title: 'Edilizia Commerciale', desc: 'Progettazione e costruzione di spazi commerciali, uffici e strutture industriali su misura per ogni esigenza.' },
    { icon: PaintBucket, title: 'Finiture di Pregio', desc: 'Lavori di finitura e interior design con materiali selezionati e maestranze specializzate per ambienti unici.' },
    { icon: Shield, title: 'Sicurezza e Conformità', desc: 'Rispetto totale delle normative vigenti, gestione della sicurezza in cantiere e certificazioni complete.' },
    { icon: Clock, title: 'Project Management', desc: "Gestione completa del progetto dall'inizio alla consegna, con cronoprogramma dettagliato e reportistica trasparente." },
  ];

  const pilastri = [
    { icon: Leaf, title: 'Sostenibilità Ambientale', desc: 'Integrazione di soluzioni eco-compatibili e materiali rigenerativi per un impatto urbano positivo e duraturo nel tempo.' },
    { icon: Monitor, title: 'Innovazione Digitale', desc: 'Pianificazione avanzata tramite processi digitalizzati per ottimizzare tempi, costi e precisione costruttiva in ogni cantiere.' },
    { icon: Cog, title: 'Efficienza Operativa', desc: "Gestione diretta dell'intero ciclo immobiliare, dalla concezione al completamento, assicurando standard qualitativi d'eccellenza." },
  ];

  const progetti = [
    { img: images.project1, title: 'Villa Moderna Pescara', cat: 'Residenziale', year: '2025' },
    { img: images.project2, title: 'Residenza Lago Azzurro', cat: 'Residenziale', year: '2024' },
    { img: images.project3, title: 'Palazzo Degli Ulivi', cat: 'Residenziale', year: '2024' },
    { img: images.project4, title: 'Centro Direzionale SMR', cat: 'Commerciale', year: '2023' },
    { img: images.project5, title: 'Complesso Le Terrazze', cat: 'Residenziale', year: '2023' },
    { img: images.project6, title: 'Villa Panoramica Molise', cat: 'Residenziale', year: '2022' },
  ];

  const stats = [
    { value: '50+', label: 'Anni di Esperienza' },
    { value: '200+', label: 'Progetti Completati' },
    { value: '2', label: 'Generazioni' },
    { value: '100%', label: 'Passione' },
  ];

  return (
    <div className="sito">
      {/* NAV */}
      <nav className={`sito-nav ${scrolled ? 'sito-nav-scrolled' : ''}`}>
        <div className="sito-nav-inner">
          <div className="sito-brand" onClick={() => scrollTo('hero')}>
            <img src={LOGO} alt="CG" className="sito-brand-logo" />
            <span className="sito-brand-name">COLABELLA<span className="sito-brand-light">GROUP</span></span>
          </div>
          <div className={`sito-links ${menuOpen ? 'sito-links-open' : ''}`}>
            <button onClick={() => scrollTo('hero')}>Home</button>
            <button onClick={() => scrollTo('chi-siamo')}>Chi Siamo</button>
            <button onClick={() => scrollTo('pilastri')}>Valori</button>
            <button onClick={() => scrollTo('servizi')}>Servizi</button>
            <button onClick={() => scrollTo('progetti')}>Progetti</button>
            <button onClick={() => scrollTo('contatti')}>Contatti</button>
          </div>
          <a href="tel:+393202711608" className="sito-nav-cta">Chiama Ora</a>
          <button className="sito-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {/* HERO */}
      <section id="hero" className="sito-hero">
        <div className="sito-hero-bg" style={{ backgroundImage: `url(${images.hero})` }} />
        <div className="sito-hero-overlay" />
        <div className="sito-hero-content">
          <p className="sito-hero-pre">COSTRUIAMO IL FUTURO</p>
          <h1 className="sito-hero-title">Eccellenza<br />nell'Edilizia</h1>
          <p className="sito-hero-sub">Dal 1970, due generazioni al servizio dell'edilizia di qualità. Tradizione artigianale e innovazione tecnologica al vostro servizio.</p>
          <div className="sito-hero-btns">
            <button className="sito-btn-primary" onClick={() => scrollTo('progetti')}>I Nostri Progetti <ArrowRight size={18} /></button>
            <button className="sito-btn-outline" onClick={() => scrollTo('contatti')}>Richiedi Preventivo</button>
          </div>
        </div>
        <button className="sito-scroll-down" onClick={() => scrollTo('chi-siamo')}>
          <ChevronDown size={28} />
        </button>
      </section>

      {/* STATS BAR */}
      <section className="sito-stats">
        {stats.map((s, i) => (
          <div key={i} className="sito-stat">
            <span className="sito-stat-val">{s.value}</span>
            <span className="sito-stat-lbl">{s.label}</span>
          </div>
        ))}
      </section>

      {/* CHI SIAMO */}
      <section id="chi-siamo" className="sito-section sito-about">
        <div className="sito-section-inner sito-about-grid">
          <div className="sito-about-images">
            <img src={images.about} alt="Cantiere" className="sito-about-img1" />
            <img src={images.about2} alt="Progetto" className="sito-about-img2" />
          </div>
          <div className="sito-about-text">
            <p className="sito-section-pre">CHI SIAMO</p>
            <h2 className="sito-section-title">La Nostra Storia</h2>
            <p className="sito-about-desc">
              Colabella Group nasce all'inizio degli anni '70, fondata da <strong>Leo Colabella</strong> con la passione
              per l'edilizia di qualità e il desiderio di costruire qualcosa di duraturo. Da una piccola impresa familiare
              a San Martino in Pensilis, l'azienda è cresciuta anno dopo anno, guadagnandosi la fiducia dei clienti
              grazie a lavori eseguiti con cura artigianale e materiali di prima scelta.
            </p>
            <p className="sito-about-desc">
              Oggi l'azienda è guidata dal figlio <strong>Antonio Colabella</strong>, che porta avanti la tradizione
              di famiglia unendo l'esperienza tramandata dal padre alle più moderne tecniche costruttive.
              Con oltre <strong>50 anni di storia</strong>, Colabella Group rappresenta una garanzia di affidabilità,
              qualità e rispetto dei tempi nel settore edile del centro-sud Italia.
            </p>
            <p className="sito-about-desc">
              La nostra filosofia resta quella di sempre: <strong>costruire bene</strong>, con materiali selezionati,
              maestranze qualificate e un rapporto diretto e trasparente con ogni cliente.
            </p>
            <div className="sito-about-values">
              <div className="sito-value"><span className="sito-value-num">01</span><div><h4>Tradizione</h4><p>Oltre 50 anni di esperienza, da padre a figlio</p></div></div>
              <div className="sito-value"><span className="sito-value-num">02</span><div><h4>Affidabilità</h4><p>Rispetto dei tempi, del budget e della parola data</p></div></div>
              <div className="sito-value"><span className="sito-value-num">03</span><div><h4>Innovazione</h4><p>Tecniche costruttive moderne con cura artigianale</p></div></div>
            </div>
          </div>
        </div>
      </section>

      {/* PILASTRI */}
      <section id="pilastri" className="sito-section sito-pilastri">
        <div className="sito-section-inner">
          <div className="sito-section-header">
            <p className="sito-section-pre">I NOSTRI PILASTRI</p>
            <h2 className="sito-section-title">I Valori che ci Guidano</h2>
            <p className="sito-section-subtitle">Tre principi fondamentali che definiscono il nostro modo di operare e costruire il futuro.</p>
          </div>
          <div className="sito-pilastri-grid">
            {pilastri.map((p, i) => {
              const Icon = p.icon;
              return (
                <div key={i} className="sito-pilastro-card">
                  <div className="sito-pilastro-num">{String(i + 1).padStart(2, '0')}</div>
                  <div className="sito-pilastro-icon"><Icon size={32} /></div>
                  <h3>{p.title}</h3>
                  <p>{p.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* SERVIZI */}
      <section id="servizi" className="sito-section sito-services">
        <div className="sito-section-inner">
          <div className="sito-section-header">
            <p className="sito-section-pre">I NOSTRI SERVIZI</p>
            <h2 className="sito-section-title">Cosa Facciamo</h2>
            <p className="sito-section-subtitle">Offriamo una gamma completa di servizi nel settore edile, dalla progettazione alla consegna chiavi in mano.</p>
          </div>
          <div className="sito-services-grid">
            {servizi.map((s, i) => {
              const Icon = s.icon;
              return (
                <div key={i} className="sito-service-card">
                  <div className="sito-service-icon"><Icon size={28} /></div>
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* PROGETTI */}
      <section id="progetti" className="sito-section sito-projects">
        <div className="sito-section-inner">
          <div className="sito-section-header">
            <p className="sito-section-pre">PORTFOLIO</p>
            <h2 className="sito-section-title">I Nostri Progetti</h2>
            <p className="sito-section-subtitle">Una selezione dei nostri lavori più recenti che testimoniano la qualità e l'attenzione al dettaglio.</p>
          </div>
          <div className="sito-projects-grid">
            {progetti.map((p, i) => (
              <div key={i} className="sito-project-card">
                <img src={p.img} alt={p.title} />
                <div className="sito-project-overlay">
                  <span className="sito-project-cat">{p.cat} — {p.year}</span>
                  <h3>{p.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="sito-cta-section" style={{ backgroundImage: `url(${images.hero2})` }}>
        <div className="sito-cta-overlay" />
        <div className="sito-cta-content">
          <h2>Hai un Progetto in Mente?</h2>
          <p>Contattaci per una consulenza gratuita e senza impegno. Trasformiamo le tue idee in realtà.</p>
          <button className="sito-btn-primary sito-btn-lg" onClick={() => scrollTo('contatti')}>Richiedi Preventivo <ArrowRight size={20} /></button>
        </div>
      </section>

      {/* CONTATTI */}
      <section id="contatti" className="sito-section sito-contacts">
        <div className="sito-section-inner sito-contacts-grid">
          <div className="sito-contact-info">
            <p className="sito-section-pre">CONTATTI</p>
            <h2 className="sito-section-title">Parliamo del Tuo Progetto</h2>
            <p className="sito-contact-desc">Siamo a tua disposizione per rispondere a qualsiasi domanda. Compila il modulo o contattaci direttamente.</p>
            <div className="sito-contact-items">
              <a href="tel:+393202711608" className="sito-contact-item">
                <Phone size={20} />
                <div><h4>Telefono</h4><p>+39 320 271 1608</p></div>
              </a>
              <a href="mailto:info@colabella.it" className="sito-contact-item">
                <Mail size={20} />
                <div><h4>Email</h4><p>info@colabella.it</p></div>
              </a>
              <div className="sito-contact-item">
                <MapPin size={20} />
                <div><h4>Sede</h4><p>Via Alba, 1 — 86046<br />San Martino in Pensilis (CB)</p></div>
              </div>
            </div>
          </div>
          <form className="sito-contact-form" onSubmit={handleSubmit}>
            <input type="text" placeholder="Nome e Cognome *" required value={formData.nome} onChange={e => setFormData({...formData, nome: e.target.value})} />
            <input type="email" placeholder="Email *" required value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} />
            <input type="tel" placeholder="Telefono" value={formData.telefono} onChange={e => setFormData({...formData, telefono: e.target.value})} />
            <textarea placeholder="Descrivi il tuo progetto..." rows={5} value={formData.messaggio} onChange={e => setFormData({...formData, messaggio: e.target.value})} />
            <button type="submit" className="sito-btn-primary sito-btn-full">
              {formSent ? 'Messaggio Inviato!' : 'Invia Richiesta'}
            </button>
          </form>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="sito-footer">
        <div className="sito-footer-inner">
          <div className="sito-footer-brand">
            <img src={LOGO} alt="CG" />
            <span>COLABELLA<span style={{ fontWeight: 300 }}>GROUP</span></span>
            <p>Eccellenza nell'edilizia dal 1970</p>
          </div>
          <div className="sito-footer-links">
            <button onClick={() => scrollTo('chi-siamo')}>Chi Siamo</button>
            <button onClick={() => scrollTo('pilastri')}>Valori</button>
            <button onClick={() => scrollTo('servizi')}>Servizi</button>
            <button onClick={() => scrollTo('progetti')}>Progetti</button>
            <button onClick={() => scrollTo('contatti')}>Contatti</button>
          </div>
          <div className="sito-footer-contact">
            <p><Phone size={14} /> +39 320 271 1608</p>
            <p><Mail size={14} /> info@colabella.it</p>
            <p><MapPin size={14} /> San Martino in Pensilis (CB)</p>
          </div>
        </div>
        <div className="sito-footer-bottom">
          <p>&copy; {new Date().getFullYear()} Colabella Group — Tutti i diritti riservati</p>
        </div>
      </footer>
    </div>
  );
};

export default SitoWeb;
